import React from 'react';
import EventCard from 'components/molecules/event-card/EventCard';

function AdventurersClubClose() {
  const dateTexts = ['1955年'];
  const title = 'プレジャーアイランドおよびアドベンチャラーズクラブが閉鎖される';
  const imgUrl = 'https://seadictionary.disneyparkstory.com/wp-content/uploads/sites/2/2020/09/AdventurersClubExterior.jpg'
  const description = (
    <>
      <a href='/merriweather-adam-pleasure'>
        {'メリウェザー・アダム・プレジャー'}
      </a>
      {'が消えて以降、プレジャーアイランドの経営は立ち行かなくなり、プレジャーアイランドおよび'}
      <a href='/adventurers-club'>
        {'アドベンチャラーズクラブ'}
      </a>
      {'が閉鎖される。'}
    </>
  );
  const quoteDomain = 'en.wikipedia.org';

  return (
    <EventCard
      dateTexts={dateTexts}
      title={title}
      description={description}
      imgUrl={imgUrl}
      quoteDomain={quoteDomain}
    />
  );
}

export default AdventurersClubClose;
